import React from "react";
import AnimatedHeading from "../AnimatedHeading";
import { FOOTER_IMG } from "../../assetsBase";

const quickLinks = [
  { label: "Home", href: "#top" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

const serviceLinks = [
  { label: "Digital Solutions", href: "#digital" },
  { label: "Business Solutions", href: "#business" },
  { label: "Supply & Trading Solutions", href: "#supply" },
];

function Footer() {
  return (
    <footer
      className="main-footer bg_cover"
      style={{ backgroundImage: `url(${FOOTER_IMG}/footer-bg.jpg)` }}
    >
      <div className="shape">
        <img src={`${FOOTER_IMG}/footer-shape1.png`} alt="shape" />
      </div>
      <div className="container">
        <div className="footer-newsletter-wrapper pb-120">
          <div className="row align-items-center justify-content-center">
            <div className="col-xl-7 col-lg-10">
              <div className="orbia-content-box text-center text-xl-start mb-5 mb-xl-0">
                <div className="section-title text-white">
                  <span
                    className="sub-title"
                    data-aos="fade-down"
                    data-aos-duration="1000"
                  >
                    Stay Connected
                  </span>
                  <AnimatedHeading>Stay Updated with Lozrian</AnimatedHeading>
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-lg-10">
              <div
                className="orbia-newsletter-box"
                data-aos="fade-up"
                data-aos-duration="1200"
              >
                <form
                  autoComplete="off"
                  onSubmit={(event) => event.preventDefault()}
                >
                  <div className="form-group">
                    <input
                      type="email"
                      className="form_control"
                      placeholder="Email Address"
                      name="email"
                      required
                    />
                    <button className="theme-btn gradient-btn" type="submit">
                      subscribe <i className="far fa-bell"></i>
                    </button>
                  </div>
                  <div className="form-check mt-20">
                    <label
                      className="form-check-label"
                      htmlFor="orbia-newsletter-agree"
                    >
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="agree"
                        id="orbia-newsletter-agree"
                      />
                      I Agree To The Terms, Privacy Policy.
                    </label>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="footer-bottom-wrapper bg_cover"
        // style={{ backgroundImage: `url(${FOOTER_IMG}/footer-widget-bg.jpg)` }}
      >
        <div className="container">
          <div className="footer-widget-area  pb-55">
            <div className="row">
              <div className="col-lg-4 col-md-6 order-1">
                <div
                  className="footer-widget footer-about-widget mb-40"
                  data-aos="fade-up"
                  data-aos-duration="800"
                >
                  <div className="widget-content">
                    <div className="footer-logo mb-30">
                      <a href="#top">
                        <img
                          src="/img/logoFooter.svg"
                          alt="Lozrian"
                          style={{ filter: "brightness(0) invert(1)" }}
                          height={40}
                        />
                      </a>
                    </div>
                    <p>
                      A multidisciplinary solutions company bringing together
                      technology, business expertise, and international supply
                      capabilities under one brand.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 col-md-12 order-3 order-lg-2">
                <div className="row">
                  <div className="col-md-6">
                    <div
                      className="footer-widget footer-nav-widget mb-40"
                      data-aos="fade-up"
                      data-aos-duration="1000"
                    >
                      <div className="widget-content">
                        <h4 className="widget-title">Quick Links</h4>
                        <div className="line-wrap">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                        <ul className="widget-nav">
                          {quickLinks.map((link) => (
                            <li key={link.label}>
                              <a href={link.href}>{link.label}</a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div
                      className="footer-widget footer-nav-widget mb-40"
                      data-aos="fade-up"
                      data-aos-duration="1200"
                    >
                      <div className="widget-content">
                        <h4 className="widget-title">Our Services</h4>
                        <div className="line-wrap">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                        <ul className="widget-nav">
                          {serviceLinks.map((service) => (
                            <li key={service.label}>
                              <a href={service.href}>{service.label}</a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 order-2 order-lg-3">
                <div
                  className="footer-widget footer-contact-info-widget mb-40"
                  data-aos="fade-up"
                  data-aos-duration="1400"
                >
                  <div className="widget-content">
                    <h4 className="widget-title">Contact Info</h4>
                    <div className="line-wrap">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                    <div className="orbia-info-box style-two mb-20">
                      <div className="icon">
                        <i className="far fa-envelope"></i>
                      </div>
                      <div className="info">
                        <p>
                          <a href="mailto:info@lozrian.com">info@lozrian.com</a>
                        </p>
                      </div>
                    </div>
                    <div className="orbia-info-box style-two mb-20">
                      <div className="icon">
                        <i className="far fa-globe"></i>
                      </div>
                      <div className="info">
                        <p>Serving regional and international markets</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="copyright-area">
            <div className="row">
              <div className="col-lg-6">
                <div className="copyright-text text-lg-start text-center">
                  <p>
                    &copy; {new Date().getFullYear()} <span>Lozrian</span>. All
                    Rights Reserved.
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="copyright-link text-lg-end text-center">
                  <button type="button" className="copyright-link-btn">
                    Terms &amp; Conditions
                  </button>
                  <button type="button" className="copyright-link-btn">
                    Privacy Policy
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
